import { forwardRef, ForwardRefRenderFunction, HTMLAttributes } from 'react';
import { Slot } from '@radix-ui/react-slot';

type Props = Omit<HTMLAttributes<HTMLLabelElement>, 'className'> & {
  asChild?: boolean;
};

const CheckboxFieldLabelRenderFunction: ForwardRefRenderFunction<
  HTMLLabelElement,
  Props
> = ({ asChild, ...attrs }, ref) => {
  const Element = asChild ? Slot : 'label';

  return (
    <Element
      {...attrs}
      ref={ref}
      className="label-md text-marine-high-emphasis"
    />
  );
};

export const CheckboxFieldLabel = forwardRef<HTMLLabelElement, Props>(
  CheckboxFieldLabelRenderFunction,
);
